var _line, _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGitBranch = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 4,
  x2: 4,
  y1: 2,
  y2: 10
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 4,
  r: 2
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 4,
  cy: 12,
  r: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 6a6 6 0 0 1-6 6"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGitBranch);
export default ForwardRef;